import { render, staticRenderFns } from "./CommercialVehicleDetailsForm.vue?vue&type=template&id=40635ec3&scoped=true"
import script from "./CommercialVehicleDetailsForm.vue?vue&type=script&lang=js"
export * from "./CommercialVehicleDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./CommercialVehicleDetailsForm.vue?vue&type=style&index=0&id=40635ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40635ec3",
  null
  
)

export default component.exports